import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

type PriceSchemeOverviewInfoFullImport = {
  items_with_prices_count: number;
};

type PriceSchemeOverviewInfoPartialImport = {
  item_price_changes_count: number;
};

export type PriceSchemeOverviewResponse = {
  type: 'price-schemes-import';
  data: {
    file_name: string;
    errors?: {
      count: number;
      report_url: string;
    };
    info: PriceSchemeOverviewInfoFullImport | PriceSchemeOverviewInfoPartialImport;
  };
};

export const getPriceSchemeOverview = async (eventId: string): Promise<PriceSchemeOverviewResponse['data']> => {
  try {
    const res = await fetch(`${API_URL}/pricing/schemes/import/${eventId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const result = (await res.json()) as PriceSchemeOverviewResponse;
    if (res.status !== Status.SUCCESS) {
      throw new Error('Invalid Response');
    }

    return result.data;
  } catch (e) {
    throw new Error(e instanceof Error ? e.message : 'Failed to get price scheme overview');
  }
};
